import {BrowserRouter} from "react-router-dom";
import React,{Suspense, useState} from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import "nprogress/nprogress.css";
import Router from "./routes/routes";
import ScrollToTop from "./components/ScrollToTop";
import PurchasedTicketModal from "./components/modal/PurchasedTicketModal";
import PurchaseSuccessModal from "./components/modal/PurchaseSuccessModal";
import GoogleRedirectReturn from "./components/auth/GoogleRedirectReturn";
const App=()=>{
    const design=(
        <>
       <BrowserRouter>
        {/*
            Resets scroll on every route change. Must be a child of
            <BrowserRouter> so useLocation() resolves correctly.
        */}
        <ScrollToTop/>
        {/* Finishes a redirect-flow Google sign-in when the browser lands back
            with #gauth=… (event short hosts). Renders nothing. */}
        <GoogleRedirectReturn/>
        <Router/>
        {/* Global purchased-ticket viewer — opens inline (no navigation) when a
            ticket is tapped on My Tickets or Ticket Lookup. */}
        <PurchasedTicketModal/>
        {/* Post-purchase confirmation, raised over /my-tickets on desktop. */}
        <PurchaseSuccessModal/>
        <ToastContainer/>
       </BrowserRouter>
        </>
    );
    return design;
}

export default App;
